module.exports = __webpack_public_path__ + "img/2f18d29.webp";